export const Images = {
  momo_square_logo: '/images/momo_square_logo.png',
  bg_with_pattern: '/assets/img/bg_with_pattern.png',
  background_jd: '/assets/img/background_jd.png',
  icon_heart: '/assets/img/icon_heart.png',
  icon_haha: '/assets/img/icon_haha.png',
  folder_background: '/assets/img/folder_background.png',
  background_card: '/assets/img/background_card.png',
  ribbon: '/assets/img/ribbon.png',
  background_paper: '/assets/img/background_paper.png',
  badge_top1: '/assets/img/badge_top1.png',
  badge_top2: '/assets/img/badge_top2.png',
  badge_top3: '/assets/img/badge_top3.png',
  icon_blink: '/assets/img/icon_blink.png',
}
